import { getSiteConfig } from '@shared/config';

type SelectableNotificationChannels = {
  email: boolean;
  sms: boolean;
  phone: boolean;
  post: boolean;
};

type ContactPreferencesPayload = {
  verticals: {
    lottery: boolean;
    casinoAndScratchcards: boolean;
    sportsbook: boolean;
    bingo: boolean;
  };
  notificationChannels: SelectableNotificationChannels & { trustedPartners?: boolean };
};

const ALL_VERTICALS: (keyof ContactPreferencesPayload['verticals'] | 'casino')[] = ['lottery', 'casino', 'sportsbook'];

function getDefaultSelectableChannels(): string[] {
  const { availableChannels } = getSiteConfig().CONTACT_PREFERENCES;
  return availableChannels.filter(channel => channel !== 'trustedPartners');
}

function resolveEffectiveChannels(verticals: string[], channels: string[]): string[] {
  const hasProducts = verticals.length > 0;
  const hasChannels = channels.length > 0;

  if (!hasProducts) return [];
  if (hasProducts && !hasChannels) return getDefaultSelectableChannels();
  return channels;
}

function resolveEffectiveVerticals(channels: string[], verticals: string[]): string[] {
  const hasProducts = verticals.length > 0;
  const hasChannels = channels.length > 0;

  if (!hasChannels) return [];
  if (hasChannels && !hasProducts) return [...ALL_VERTICALS];
  return verticals;
}

function buildContactPreferencesPayload(verticals: string[], channels: string[]): ContactPreferencesPayload {
  const { availableChannels } = getSiteConfig().CONTACT_PREFERENCES;

  return {
    verticals: {
      lottery: verticals.includes('lottery'),
      casinoAndScratchcards: verticals.includes('casino'),
      sportsbook: verticals.includes('sportsbook'),
      bingo: false,
    },
    notificationChannels: {
      email: channels.includes('email'),
      sms: channels.includes('sms'),
      phone: channels.includes('phone'),
      post: channels.includes('post'),
      ...(availableChannels.includes('trustedPartners') ? { trustedPartners: channels.includes('trustedPartners') } : {}),
    },
  };
}

export { buildContactPreferencesPayload, resolveEffectiveChannels, resolveEffectiveVerticals, type ContactPreferencesPayload };
